<template>
    <TotemSelect
        :options="options"
        :placeholder="placeholder"
        @input="onInput"
        class="filter-select"
        ref="select"
        :isFilter="true"
        :closeOnSelect="false"
        v-on:removeOptionFromFilters="removeFilterValue"
        :class="`${$totemLang}-${filterKey}`"
        :reduce="({ value, labelWithoutCount: label }) => ({ value, label })"
        :value=null
    />
</template>

<script>
    import filteringHelper from 'components/user/organizationreport/filters/helpers/filteringHelper'
    import { translateWithDefault } from 'helpers/i18nHelper'

    export default {
        name: 'reporting-select-filter',
        mixins: [ filteringHelper ],
        inject: ['tab'],
        props: {
            translationString: {
                type: String,
                required: true
            },
            filterKey: {
                type: String,
                required: true
            },
            labels: {
                type: Object
            }
        },
        computed: {
            placeholder () {
                return this.$t(this.translationString)
            },
            options () {
                return this.filtersWithFacets[this.filterKey].map((filterItem, key) => ({
                    label: this.labels ? `${this.labels[key]} (${filterItem.count})` : `${filterItem.label} (${filterItem.count})`,
                    labelWithoutCount: filterItem.label,
                    value: filterItem.value,
                    selected: filterItem.selected,
                })).filter(value => value.labelWithoutCount !== '')
            },
            currentFilter () {
                return this.filtersWithKey(this.filterKey)
            }
        },
        watch: {
            currentFilter (val) {
                if ((Array.isArray(val) && val.length === 0) || !val) {
                    return this.clearWithoutEmit()
                }
            }
        },
        methods: {
            onInput (payload) {
                if (payload === null) {
                    this.$store.dispatch(this.getClearFilterRoute, { key: this.filterKey })
                } else {
                    const option = this.filtersWithFacets[this.filterKey].find(filterItem => filterItem.value === payload.value)
                    if (option.selected) {
                        return
                    }
                    this.$store.dispatch(this.getAddFilterValueRoute, {
                        ...payload,
                        key: this.filterKey
                    })
                }
            },
            clear () {
                if (this.$refs.select) {
                    this.$refs.select.clear()
                }
            },
            clearWithoutEmit () {
                if (this.$refs.select) {
                    this.$refs.select.clearWithoutEmit()
                }
            },
            removeFilterValue (option) {
                this.$store.dispatch(this.getRemoveFilterRoute, { key: this.filterKey, value: option.value })
            }
        }
    }
</script>
